// Centralized company info — easily editable
export const company = {
  name: "Koning Aannemersbedrijf",
  short: "Koning",
  tagline: "Vakmanschap zonder compromissen",
  founded: 2008,
  region: "Zuid-Holland",
  // Real company data
  phone: "06 - 35 65 06 10",
  phoneHref: "tel:+31635650610",
  whatsapp: "+31 6 35 65 06 10",
  whatsappHref: "https://wa.me/31635650610",
  email: "info@koningaannemers.nl",
  emailHref: "mailto:info@koningaannemers.nl",
  address: {
    street: "",
    postalCode: "",
    city: "Maassluis",
    country: "Nederland",
  },
  kvk: "94094918",
  btw: "NL005064619B63",
  hours: [
    { day: "Maandag — Vrijdag", time: "08:00 — 18:00" },
    { day: "Zaterdag", time: "Gesloten" },
    { day: "Zondag", time: "Gesloten" },
  ],
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com",
  },
  // Werkspot Pro profile — reviewCount hidden until confirmed via real Werkspot data
  werkspot: {
    profileUrl: "https://www.werkspot.nl/profiel/koning-aannemersbedrijf/reviews",
  },
  stats: [
    { value: "15+ jaar", label: "Praktijkervaring" },
    { value: "VCA", label: "Gecertificeerde medewerkers" },
    { value: "Vast team", label: "Met vaste specialisten" },
  ],
  certifications: [
    "VCA-gecertificeerde medewerkers",
    "KvK Geregistreerd",
    "Werkspot Pro",
  ],
  domain: "koningaannemers.nl",
  url: "https://koningaannemers.nl",
};
